import { http } from "../core";
import { URL } from "./_url";
import { StatusCode } from "../constant";
export const apiFetchCommunitiesList = async (divisionCode: string) => {
  const response = await http.get(URL.COMMUNITIES_LIST(divisionCode));
  if (response && response.status >= StatusCode.BADREQUEST) {
    console.log('Error fetching communities list:', response.status, response.statusText);
    throw new Error(response.status);
  }
  return response || null;
};  